import React from 'react';
import { cn } from '../../utils/cn';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  helperText?: string;
}

export const Input: React.FC<InputProps> = ({
  className,
  error = false,
  helperText,
  ...props
}) => {
  return (
    <div className="w-full">
      <input
        className={cn(
          'w-full px-3 py-2 border rounded-lg shadow-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 disabled:opacity-50',
          'bg-gray-800 border-gray-700 text-white',
          error && 'border-red-500 focus:ring-red-500 focus:border-red-500',
          className
        )}
        {...props}
      />
      {helperText && (
        <p className={cn(
          'mt-1 text-sm',
          error ? 'text-red-400' : 'text-gray-400'
        )}>
          {helperText}
        </p>
      )}
    </div>
  );
};
